import { getManagementApiBaseUrl } from '../../utils/management-api';

export class CampaignConfigAuditEndpoint {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${getManagementApiBaseUrl()}/campaign-config-audit`;
	}

	changes() {
		return `${this.baseUrl}/changes`;
	}

	sourcesOptions() {
		return `${this.baseUrl}/sourcesOptions`;
	}
}
